var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("nav", {
      staticClass: "navbar navbar-expand-lg navbar-dark bg-primary",
    }),
    _c("div", { attrs: { id: "page-wrapper" } }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }